import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { WhoAmIService } from 'src/app/auth/services/whoami.service';

@Injectable({
  providedIn: 'root',
})
export class BlockRootUserGuard {
  private whoami = inject(WhoAmIService);
  private router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    // If user is root, redirect to analytics page
    if (this.whoami.isRoot()) {
      this.router.navigate(['/analytics']);
      return of(false);
    }
    return of(true);
  }
}
